module.exports = __webpack_public_path__ + "media/images/story/typo/aboutMode-b50abf8bf3dfcf1a1dd22c7ee760d9a7.svg";